/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyQuestionWithOptions = {
    properties: {
        id: {
    type: 'number',
},
        questionType: {
    type: 'string',
},
        questionText: {
    type: 'string',
},
        title: {
    type: 'string',
},
        subTitle: {
    type: 'string',
},
        createdAt: {
    type: 'string',
    format: 'date-time',
},
        options: {
    type: 'array',
    contains: {
        type: 'StaffSurveyQuestionOption',
    },
},
    },
};